export default __webpack_public_path__ + "ed8ffe37ce3a882e49e9d680ee56d124.svg";